import { useTranslation } from 'react-i18next'
import { ConfirmActionDialog } from 'shared/components'
import { SystemAdminModeDenial } from 'shared/types'

interface SystemAdminModeDenialDialogsProps {
  denial: SystemAdminModeDenial | null
  onClose: () => void
  onSignInAgain: () => void
  onEnableTwoFactor: () => void
}

const SystemAdminModeDenialDialogs = ({
  denial,
  onClose,
  onSignInAgain,
  onEnableTwoFactor,
}: SystemAdminModeDenialDialogsProps) => {
  const { t } = useTranslation()

  return (
    <>
      <ConfirmActionDialog
        open={denial === SystemAdminModeDenial.SESSION_EXPIRED}
        onClose={onClose}
        onConfirm={onSignInAgain}
        title={t('viewerMode.sessionExpiredLogin.title')}
        message={t('viewerMode.sessionExpiredLogin.message')}
        confirmLabel={t('viewerMode.sessionExpiredLogin.signIn')}
      />
      <ConfirmActionDialog
        open={denial === SystemAdminModeDenial.TWO_FACTOR_REQUIRED}
        onClose={onClose}
        onConfirm={onEnableTwoFactor}
        title={t('viewerMode.twoFactorRequired.title')}
        message={t('viewerMode.twoFactorRequired.message')}
        confirmLabel={t('viewerMode.twoFactorRequired.enable')}
      />
    </>
  )
}

export default SystemAdminModeDenialDialogs
